import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ajax-call',
	templateUrl:'./AjaxCallPluginCompPage.html',
	styles: [],
	styleUrls:['./AjaxCallPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AjaxCallPluginCompPage
{
	mdContent_761 = `\`\`\`java
import com.jwebmp.client.AjaxCall;
\`\`\``;
	mdContent_762 = `\`\`\`java
AjaxCall()
\`\`\``;
	mdContent_763 = `\`\`\`java
button.addEvent(new OnClickAdapter(button) {
    @Override
    public void onClick(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
        String id = call.getComponentId();
        String value = call.getValue();
    }
});
\`\`\``;
}
